module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-style', [_vm._v(" body > :first-child { height: 100%; } ")]), _vm._v(" "), _c('MenuLayer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.layersActive),
      expression: "layersActive"
    }],
    attrs: {
      "items": _vm.itemsLayer,
      "x": _vm.layerX,
      "y": _vm.layerY
    }
  }), _vm._v(" "), (_vm.loader) ? _c('Spinner') : _vm._e(), _vm._v(" "), (_vm.displayViewPdf) ? _c('ExportPdf', {
    attrs: {
      "modules": _vm.getEltModules,
      "accessories": _vm.accessories,
      "hideFrame": _vm.optionhideframe,
      "preview": _vm.previewPdf,
      "compression": _vm.compression
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTool === true) ? _c('div', [_c('div', {
    staticClass: "flexContainer jc-c full",
    attrs: {
      "id": "menuView"
    }
  }, [_c('ul', {
    staticClass: "views flexContainer listNone center"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "pointer",
      class: [{
        active: _vm.activeTab(tab.id),
        mobileNot: tab.id === 'shades' || tab.id === 'blackwhite' || tab.id === 'hide'
      }],
      on: {
        "click": function($event) {
          _vm.views(tab.id, $event);
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t(tab.text)) + "\n                ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flexContainer fd-c content-plano-builder"
  }, [_c('div', {
    staticClass: "rel flexContainer",
    attrs: {
      "id": "planoContainer"
    }
  }, [(_vm.showTool) ? _c('div', {
    staticClass: "mobileNot",
    attrs: {
      "id": "toolBar"
    }
  }, [_c('ul', {
    staticClass: "listNone listAction"
  }, [(_vm.lock === false) ? _c('li', {
    staticClass: "pointer",
    class: {
      selection: _vm.modeSelection, selectionSvg: _vm.modeSelection === false
    },
    attrs: {
      "title": _vm.$t('planobuilder.selection')
    },
    on: {
      "click": _vm.selectionAction
    }
  }) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      pan: _vm.modePan, panAction: _vm.modePan === false
    },
    attrs: {
      "title": _vm.$t('planobuilder.pan')
    },
    on: {
      "click": _vm.panAction
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "pointer icon-ungroup-off",
    attrs: {
      "title": _vm.$t('planobuilder.ungroupall')
    },
    on: {
      "mousedown": _vm.removeGroupAll
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "listNone listZoom"
  }, [_c('li', {
    staticClass: "zoomIn",
    attrs: {
      "title": _vm.$t('planobuilder.zoomIn')
    },
    on: {
      "click": _vm.zoomIn
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "zoomOut",
    attrs: {
      "title": _vm.$t('planobuilder.zoomOut')
    },
    on: {
      "click": _vm.zoomOut
    }
  }), _vm._v(" "), (_vm.lock === false) ? _c('li', {
    staticClass: "pointer",
    class: {
      moduleZ: _vm.zoomModule, zoomModule: _vm.zoomModule === false
    },
    attrs: {
      "title": _vm.$t('planobuilder.zoomModule')
    },
    on: {
      "click": _vm.zoomModuleAction
    }
  }) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      pos: _vm.posInit, posInit: _vm.posInit === false
    },
    attrs: {
      "title": _vm.$t('planobuilder.posInit')
    },
    on: {
      "click": _vm.planoPosInit,
      "mousedown": _vm.planoPosInitMousedown
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "listNone listLayers"
  }, [_c('li', {
    staticClass: "icon-layers",
    class: {
      'layers-on': _vm.layersActive, 'layers-off': _vm.layersActive === false
    },
    on: {
      "click": _vm.activeLayers
    }
  })])]) : _vm._e(), _vm._v(" "), _c('svg', {
    ref: "builder",
    staticClass: "svg-builder",
    attrs: {
      "id": "builder"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showTool && _vm.lock === false && _vm.hasAccessUpdate('plano_builder') && _vm.getShowRestore === false) ? _c('div', {
    staticClass: "flexContainer mobileNot",
    class: {
      visibility: _vm.modeSelection === false
    },
    attrs: {
      "id": "menuSelection"
    }
  }, [_c('ul', {
    staticClass: "flexContainer listNone"
  }, [_c('li', {
    attrs: {
      "id": "content-count"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../../static/assets/checked.svg"),
      "width": "16px",
      "height": "16px"
    }
  }), _vm._v("   " + _vm._s(_vm.countSelectComponents) + "\n                        selected elements\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      disabled: _vm.countSelectModules < 1
    },
    attrs: {
      "id": "editModule"
    },
    on: {
      "click": _vm.editModule
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("planoSelect.edit")) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      disabled: _vm.countSelectModules < 1
    },
    on: {
      "click": _vm.duplicate
    }
  }, [_vm._v(_vm._s(_vm.$t("planoSelect.duplicate")))]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      disabled: _vm.countSelectModules <= 1
    },
    attrs: {
      "id": "bt-group-module"
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("planoSelect.group")) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      disabled: _vm.groupSelected === null
    },
    attrs: {
      "id": "bt-degroup-module"
    },
    on: {
      "click": _vm.removeGroup
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("planoSelect.ungroup")) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      disabled: _vm.countSelectModules < 1
    },
    on: {
      "click": _vm.addFav
    }
  }, [_vm._v(_vm._s(_vm.$t("planoSelect.addToFavorite")))]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      disabled: _vm.countSelectModules < 1
    },
    on: {
      "click": _vm.addScratch
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("planoSelect.addToScratchpad")) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      disabled: _vm.countSelectComponents < 1
    },
    on: {
      "click": _vm.deleteModuleAction
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("planoSelect.deleteModule")) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "content-highlight pointer"
  }, [_vm._v("\n                        Hightlight:\n                        "), _vm._l((_vm.highlightsMenu), function(highlightMenu) {
    return _c('span', {
      key: highlightMenu.id,
      staticClass: "pointer bt-highlight",
      class: {
        disabled: _vm.countSelectComponents < 1
      },
      style: ('background-color:' + highlightMenu.args[1]),
      on: {
        "click": function () { return highlightMenu.action.apply(null, highlightMenu.args); }
      }
    })
  })], 2), _vm._v(" "), _c('li', {
    staticClass: "pointer",
    class: {
      disabled: _vm.countSelectComponents < 1
    },
    on: {
      "click": _vm.addCommentAction
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("planoSelect.addComment")) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "pointer abs",
    attrs: {
      "id": "test"
    },
    on: {
      "click": _vm.test
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('ModalComment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCommentModal),
      expression: "showCommentModal"
    }],
    on: {
      "closeCommentModalEvent": function($event) {
        _vm.closeCommentModal($event);
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f64ff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/PlanoEditor.vue
// module id = 3242
// module chunks = 0